import React from 'react';
import { generateClassName } from '../b2b-common/helpers';

import './MariaQuestion.css';

const MariaQuestion = ({ question = '', className = null }) => {
    return (
        question && question.length > 0 && (
            <div className={generateClassName("maria-question", "-container", className)}>
                {question}
            </div>
        )
    );
};

export default MariaQuestion;